<template>
  <div>
    <v-dialog v-model="model" max-width="720" scrollable persistent>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Selecionar dentista
          </v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <v-row wrap align-center white class="pl-5 pr-5">
            <div v-if="!dentistaSelecionado" class="container-selecao container-nao-selecionado">
              <label>Nenhum dentista selecionado!</label>
            </div>
            <div v-else class="container-selecionado">
              <div class="mr-5">
                <foto-avatar :foto-url="dentistaSelecionado.foto" class-avatar="imagem-dentista"/>
              </div>
              <div>
                <div class="selecionado-label">
                  <span class="primary--text" style="font-size: 14px">Nome</span>
                  <p>{{ dentistaSelecionado.nome }}</p>
                </div>
                <div class="container-info-dentista">
                  <div class="selecionado-label">
                    <span class="primary--text" style="font-size: 14px">Cargo</span>
                    <p>{{ dentistaSelecionado.cargo }}</p>
                  </div>
                  <div class="selecionado-label ml-5">
                    <span class="primary--text" style="font-size: 14px">Sexo</span>
                    <p>{{ dentistaSelecionado.sexo }}</p>
                  </div>
                </div>
              </div>
            </div>
          </v-row>
          <v-row wrap align-center white class="pl-5 pr-5">
            <v-autocomplete
                v-model="dentistaSelecionado"
                name="selectDentista"
                placeholder="Pesquise por nome..."
                no-data-text="Nenhum dentista encontrado..."
                :items="listaDentistas"
                item-text="nome"
                return-object
                :loading="estaBuscandoDentistas"
                :search-input.sync="buscarDentistasDinamicamente"
            >
              <template v-slot:item="{item}">
                <label class="auto-complete-item-text">{{ item.nome }}<label
                    class="dentista-info-pesquisa">({{ item.cargo }})</label></label>
              </template>
            </v-autocomplete>
          </v-row>
        </v-card-text>
        <v-container>
          <v-row wrap align-center white class="pl-10 pr-10 row-bottom">
            <botao-cancelar @cancelar="fecharModal"/>
            <div style="display: flex; flex-direction: row">
              <botao-acao
                  hideBorder
                  :disabled="!dentistaSelecionado"
                  @click="confimarSelecaoDentista">
                <v-icon>mdi-magnify</v-icon>
                Confirmar
              </botao-acao>
            </div>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import {actionTypes} from '@/core/constants'
import BotaoCancelar from '@/views/components/BotaoCancelar'
import BotaoAcao from '@/views/components/BotaoAcao.vue'
import FotoAvatar from '@/views/components/FotoAvatar.vue'

export default {
    name: 'PesquisaDentistaModal',
    components: {FotoAvatar, BotaoAcao, BotaoCancelar},
    props: {
        value: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            dentistaSelecionado: null,
            listaDentistas: [],
            estaBuscandoDentistas: false,
            buscarDentistasDinamicamente: null,
        }
    },
    watch: {
        buscarDentistasDinamicamente(val) {
            if (val) {
                if (this.estaBuscandoDentistas) return

                if (val.length > 2) {
                    this.buscarDentistas(val)
                }
            } else {
                this.buscarDentistas()
            }
        },
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    async mounted() {
        await this.buscarDentistas()
    },
    methods: {
        async buscarDentistas(conteudo) {
            this.estaBuscandoDentistas = true
            const resposta = await this.$store.dispatch(actionTypes.AGENDA.BUSCAR_TODOS_DENTISTAS_SEM_PAGINACAO, conteudo)
            if (resposta) {
                this.listaDentistas = resposta.items
            }
            this.estaBuscandoDentistas = false
        },
        confimarSelecaoDentista() {
            if (!this.dentistaSelecionado) {
                this.mostrarNotificacaoErro('Selecione um dentista!')
                return
            }
            this.model = false
            this.$emit('confirmarDentistaSelecionado', this.dentistaSelecionado)
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalPesquisaDentista')
        },
    }
}
</script>

<style scoped lang="stylus">

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding-top 10px
  padding-bottom 10px
  display flex
  justify-content space-between

.container-selecao
  background-color #E0E0E0
  height 150px
  width 100%
  display flex
  flex-direction column
  justify-content center
  align-items center
  border-radius 5px

.container-nao-selecionado
  font-weight bold
  font-size 24px

.container-selecionado
  background-color #E0E0E0
  height 150px
  width 100%
  display flex
  flex-direction row
  align-items center
  border-radius 5px
  padding 10px
  font-size 20px

.container-info-dentista
  display flex
  margin-top 10px

.selecionado-label
  font-weight bold

.auto-complete-item-text
  font-size 14px !important
  color #555 !important

.auto-complete-item-text:hover
  cursor pointer

.dentista-info-pesquisa
  background-color #E0E0E0
  margin-left 5px
  border-radius 5px
  padding 2px

.imagem-dentista
  height 90px
  width 90px
  border-radius 50%
  border 2px solid #eee
  align-self center

</style>